import { render, staticRenderFns } from "./settingHome.vue?vue&type=template&id=61a034c2&scoped=true"
import script from "./settingHome.vue?vue&type=script&lang=js"
export * from "./settingHome.vue?vue&type=script&lang=js"
import style0 from "./settingHome.vue?vue&type=style&index=0&id=61a034c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a034c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a034c2')) {
      api.createRecord('61a034c2', component.options)
    } else {
      api.reload('61a034c2', component.options)
    }
    module.hot.accept("./settingHome.vue?vue&type=template&id=61a034c2&scoped=true", function () {
      api.rerender('61a034c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/settingHome.vue"
export default component.exports